import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/hu'
import 'dayjs/locale/pl'
import 'dayjs/locale/ro'
import 'dayjs/locale/ru'
import 'dayjs/locale/uk'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(localeData)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(utc)

export function setDayjsLocale(locale: string): void {
  dayjs.locale(locale)
}
